import { render, staticRenderFns } from "./WelcomeStep1Page.vue?vue&type=template&id=1bed5906&scoped=true"
import script from "./WelcomeStep1Page.vue?vue&type=script&lang=ts"
export * from "./WelcomeStep1Page.vue?vue&type=script&lang=ts"
import style0 from "./WelcomeStep1Page.vue?vue&type=style&index=0&id=1bed5906&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bed5906",
  null
  
)

export default component.exports